import { MembershipPlan, gql } from '@yi/core';
import { SubscriptionOffer } from '@yi/core/src/gql/generated/typesClient';

import { NonNullableFields } from '../typescript-utils';

export function convertSubscriptionOffetToMembershipPlan(
  tier: gql.typesClient.SubscriptionOffer,
): NonNullable<NonNullableFields<MembershipPlan>> {
  switch (tier) {
    case SubscriptionOffer.DIGITAL:
      return {
        tier: gql.typesClient.MembershipTier.Digital,
        interval: gql.typesClient.MembershipPlanInterval.MONTH,
      };
    case gql.typesClient.SubscriptionOffer.ANNUAL:
      return {
        tier: gql.typesClient.MembershipTier.Digital,
        interval: gql.typesClient.MembershipPlanInterval.YEAR,
      };
    default:
      return {
        tier: gql.typesClient.MembershipTier.Premium,
        interval: gql.typesClient.MembershipPlanInterval.YEAR,
      };
  }
}
